/**
 * Price of each night of a stay — mirrors server/utils/nightlyPrice.js.
 * The unit page API sends `nightlyPrices` ({ "YYYY-MM-DD": price } for the next
 * year: Zaaer OTA daily price / pricing rule); a missing night uses pricePerNight.
 */
type Priced = { pricePerNight?: number; nightlyPrices?: Record<string, number> } | null | undefined;

const pad = (n: number) => String(n).padStart(2, "0");
export const ymdLocal = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const toDate = (v: Date | string) => (v instanceof Date ? v : new Date(`${String(v).slice(0, 10)}T00:00:00`));

export const priceOn = (p: Priced, ymd: string) => p?.nightlyPrices?.[ymd] ?? p?.pricePerNight ?? 0;

/** Prices of the nights in [checkIn, checkOut). */
export function stayPrices(p: Priced, checkIn?: Date | string | null, checkOut?: Date | string | null): number[] {
  if (!checkIn || !checkOut) return [];
  const a = toDate(checkIn);
  const b = toDate(checkOut);
  if (Number.isNaN(+a) || Number.isNaN(+b)) return [];
  const out: number[] = [];
  for (const d = new Date(a); d < b && out.length < 400; d.setDate(d.getDate() + 1)) out.push(priceOn(p, ymdLocal(d)));
  return out;
}

export const sumPrices = (prices: number[]) => Math.round(prices.reduce((s, n) => s + n, 0) * 100) / 100;

/** "705 × 3 nights" when every night costs the same, else null (show the average instead). */
export const uniformPrice = (prices: number[]) => (prices.length && prices.every((n) => n === prices[0]) ? prices[0] : null);
